import { memo } from "react";
import { styled } from "@mui/material/styles";
import SoftBox from "components/SoftBox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { ThemedAddCircleOutlinedIconFilled } from "assets/CXFIcons/Actions";
import { useTranslation } from "react-i18next";

const AddBranchButtonWrapper = styled(SoftBox)({
  position: "absolute",
  bottom: "-6px",
  right: "-6px",
  zIndex: 2
});

const ButtonAddBranch = ({ onClick }) => {
  const { t } = useTranslation("flowDesigner");
  return (
    <AddBranchButtonWrapper className="btn-add-condition-wrapper">
      <Tooltip title={t("buttons.add_branch")} placement="left">
        <IconButton size="small" style={{ width: "100%", height: "100%" }} onClick={onClick}>
          <ThemedAddCircleOutlinedIconFilled width="25px" height="25px" color="currentColor" />
        </IconButton>
      </Tooltip>
    </AddBranchButtonWrapper>
  );
};

export default memo(ButtonAddBranch);
